import * as React from "react";
import {SubHeaderClickHandler} from "./SubHeaderMenu";

export interface FlexHeaderProps {
    items: SubHeaderClickHandler[]
    activeID: string
    width: string;
}

export default class FlexHeader extends React.Component<FlexHeaderProps, {}> {
    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {


        return (
            <div style={{width: this.props.width, margin: 'auto'}}>
                <div className={"d-none d-md-flex flex-row justify-content-around text-center"}
                     style={{width: this.props.width, margin: 'auto'}}>

                    {this.props.items.map((item, idx) => {
                        if (idx < 8) {
                            let componentStyle = {
                                color : item.id === this.props.activeID ? 'white' : ''
                            };
                            return <div
                                key={idx}
                                className={"mt-1 p-1 pp-light-blue-background w-100 pp-font-blue font-14 font-bold"}
                                style={
                                    idx === this.props.items.length - 1 ? componentStyle : Object.assign(componentStyle,{marginRight: '0.25em'})}
                                onClick={item.handler}>
                                {item.text}
                            </div>
                        } else {
                            return
                        }
                    })}
                </div>
                <div className={"d-flex d-md-none flex-row justify-content-around text-center"}
                     style={{width: this.props.width, margin: 'auto'}}>

                    {this.props.items.slice(0,4).map((item, idx) => {
                        if (idx < 8) {
                            return <div
                                key={idx}
                                className={"mt-1 p-1 pp-light-blue-background w-100 pp-font-blue font-16 font-bold"}
                                style={
                                    idx === this.props.items.length - 1 ? {} : {marginRight: '0.25em'}}
                                onClick={item.handler}>
                                {item.text}
                            </div>
                        }
                    })}
                </div>
                <div className={"d-flex d-md-none flex-row justify-content-around text-center"}
                     style={{width: "75%", margin: 'auto'}}>

                    {this.props.items.slice(4,7).map((item, idx) => {
                        if (idx < 8) {
                            let componentStyle = {
                                color : item.id === this.props.activeID ? 'white' : ''
                            };

                            return <div
                                key={idx}
                                className={"mt-2 p-1 pp-light-blue-background w-100 pp-font-blue font-16 font-bold"}
                                style={
                                    idx === this.props.items.length - 1 ? componentStyle : Object.assign(componentStyle,{marginRight: '0.25em'})}
                                onClick={item.handler}>
                                {item.text}
                            </div>
                        }
                    })}
                </div>
            </div>
        )


    }
}